import React from "react";
import "./Text.css";
import { LanguageDirection } from "../../utility/LanguageDirection";

const Text = (props) => {
  // get language from i18


  const direction = LanguageDirection();
  const classes = props?.className ? props?.className : "";
  return <p className={`text ${classes} ${direction === "rtl" && "rtl"}`}>{props.children}</p>;
};

export default Text;
